module.exports = __webpack_public_path__ + "img/1920_header_logo_en.3369143d.svg";